const API_BASE_URL = window.__APP_CONFIG__?.API_BASE_URL || 'https://ess.endurenergy.com';
var Config = {
    apiUrl: API_BASE_URL+"/api/",
    wssUrl: API_BASE_URL.replace(/^http/, 'ws') + "/ws/pusher",
    wssUrlV2: API_BASE_URL.replace(/^http/, 'ws') + "/ws/pusher/v2",
    wssInverterUrl: API_BASE_URL.replace(/^http/, 'ws') + "/ws-inverter/pusher",
    appName_General: "BMS",
    appName_IMS: "IMS",
    appName_Tip_General: "Batteries Management System",
    appName_Tip_IMS: "Inverters Management System",
    appIcon: "images/logo.webp",
    burningPacketSize: 200,
    burningPacketSize_inverter: 240,
    bingMapKey: "AslkTsmeO4zglWKa9lKy9Z8moDUPDa-HsWSVcPD0AhjyXZAMrnecBgLIkyeuZLL_",
}

export default Config;